import { ReactNode } from 'react';

export interface Template {
  text: string;
  prefetch?: boolean;
  inputAfterWordCount?: number;
  node?: ReactNode;
  placeholder?: string;
  index?: number;
}

export const Templates: Template[] = [
  {
    text: 'The premises is currently closed. This area is under video surveillance and you are being recorded. Please leave the area.',
    prefetch: true,
  },
  {
    text: 'Person in , You are being recorded. Please leave the area or police will be dispatched.',
    prefetch: false,
    inputAfterWordCount: 2,
    placeholder: 'eg: Red shirt',
  },
  {
    text: '',
    prefetch: false,
    inputAfterWordCount: 0,
    placeholder: 'Write your custom message here..',
  },
];

export function getFinalText(
  text: string,
  inputAfterWordCount?: number,
  inputValue?: string
) {
  if (inputAfterWordCount !== undefined && inputValue) {
    const splitTextArr = text.split(' ');
    splitTextArr.splice(inputAfterWordCount, 0, inputValue);
    return splitTextArr.join(' ');
  } else {
    return text;
  }
}

export enum TalkdownMode {
  STATIC = 'static',
  DYNAMIC = 'dynamic',
  CUSTOM = 'custom',
  RECORD = 'record',
}

export const STATIC_TEMPLATE = Templates[0];
export const DYNAMIC_TEMPLATE = Templates[1];

function tidy(text: string) {
  return text.replace(/\s+([,.!?])/g, '$1');
}

export function buildTalkdownText(
  mode: TalkdownMode,
  describedPerson: string,
  typedMessage: string,
  staticText?: string
) {
  switch (mode) {
    case TalkdownMode.STATIC:
      return staticText || STATIC_TEMPLATE.text;
    case TalkdownMode.DYNAMIC:
      return describedPerson.trim()
        ? tidy(
            getFinalText(
              DYNAMIC_TEMPLATE.text,
              DYNAMIC_TEMPLATE.inputAfterWordCount,
              `"${describedPerson.trim()}"`
            )
          )
        : '';
    case TalkdownMode.CUSTOM:
      return typedMessage.trim();
    default:
      return '';
  }
}
